import { Mesh, MeshBasicMaterial, PlaneGeometry } from "three";
import { ViewType } from "../Models/AppModel.js";
import { bindedModelBase } from "../Models/BindedModel.js";
import { Point } from "./Primitive/Point.js";
import { Config } from "../Config/Config.js";
const isMobile = navigator.maxTouchPoints > 0;
/**
 * Tool to allow registering points clicking on the scene.
 */
export class RegisterPointsTool extends Mesh {
    constructor(_viewType) {
        super(new PlaneGeometry(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER, 1, 1), new MeshBasicMaterial({ visible: false }));
        this._viewType = _viewType;
        this._callbacks = {};
        this._points = [];
        this.position.setZ(100);
        this._isRegisteringClick = this._viewType === ViewType.AP ? "isRegistering2ClickAP" : "isRegistering2ClickLT";
        this.bindProperty("visible", (m) => m[this._isRegisteringClick], [this._isRegisteringClick]);
        this.bindEvent("onMouseDown", () => {
            if (this._camera) { // todo remove after refactor registerPointTool conflict
                this._oldCameraState = { position: this._camera.position.clone(), zoom: this._camera.zoom };
            }
        });
        this.bindEvent("onMouseUp", (args) => {
            if (this._camera) { // todo remove after refactor registerPointTool conflict
                this._camera.position.equals(this._oldCameraState.position) && this._camera.zoom === this._oldCameraState.zoom && this.registerPoint(args.point);
            }
        });
        this.bindEvent("onMouseInterception", (args) => {
            if (isMobile)
                return;
            this.triggerCallback("onRegMove", args.point);
        });
    }
    registerPoint(position) {
        this.pushPoint(position);
        this._points.length === this._registerTool.pointsToRegister && this.complete();
    }
    pushPoint(position) {
        const point = new Point("Registered point", 0xff0000, position, false, Config.calib_point_scale);
        this.add(point);
        this._points.push(point);
        this.triggerCallback("onRegPoint", point.position);
    }
    complete() {
        if (!this._registerTool)
            return;
        const points = this.popPoints();
        const error = this.validate(points);
        if (error === undefined) {
            this.triggerCallback("onRegSuccess", points);
            this.end(true);
        }
        else {
            this.triggerCallback("onRegError", error);
            !this._restartOnError && this.end(false);
        }
    }
    popPoints() {
        const positions = this._points.map(x => x.position);
        this.clearPoints();
        return positions;
    }
    clearPoints() {
        for (const point of this._points) {
            point.dispose(); //reuse points opt
        }
        this._points = [];
    }
    validate(points) {
        if (this._registerTool.onRegValidation) {
            return this._registerTool.onRegValidation(points);
        }
        return undefined;
    }
    triggerCallback(name, args) {
        if (!this._registerTool)
            return;
        this._callbacks[name] && this._callbacks[name](args);
        this._registerTool[name] && this._registerTool[name](args);
    }
    end(success) {
        this.triggerCallback("onRegEnd", success);
        bindedModelBase[this._isRegisteringClick] = false;
        this._registerTool = undefined;
        this._camera = undefined;
        this._callbacks = {};
    }
    start(obj, camera, callbacks = {}, restartOnError = false) {
        if (this._registerTool) {
            this.cancel();
        }
        this._camera = camera;
        this._callbacks = callbacks;
        this._registerTool = obj;
        this._restartOnError = restartOnError;
        bindedModelBase[this._isRegisteringClick] = true;
        this.triggerCallback("onRegStart");
    }
    cancel() {
        if (this._registerTool) {
            this.clearPoints();
            this.triggerCallback("onRegCancel");
            this.end(false);
        }
    }
    reset() {
        this.clearPoints();
        this.triggerCallback("onRegReset");
    }
}
//# sourceMappingURL=RegisterPointsTool.js.map